/**
 * Who To Follow Widget
 * Suggests accounts to follow in the right sidebar.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './WhoToFollowWidget.css';

const WhoToFollowWidget = () => {
  const [users, setUsers] = useState([]);
  const [followed, setFollowed] = useState({});

  useEffect(() => {
    let active = true;
    axios
      .get('/api/users/suggestions')
      .then((res) => { if (active) setUsers(res.data || []); })
      .catch(() => { /* ignore */ });
    return () => { active = false; };
  }, []);

  const handleFollow = async (id) => {
    try {
      await axios.post(`/api/users/${id}/follow`);
      setFollowed((f) => ({ ...f, [id]: true }));
    } catch (error) {
      console.error('Error following suggestion:', error);
    }
  };

  if (users.length === 0) return null;

  return (
    <div className="who-to-follow">
      <h3>Who to follow</h3>
      {users.map((u) => (
        <div key={u._id} className="wtf-row">
          <Link to={`/profile/${u._id}`} className="wtf-user">
            {u.avatar ? (
              <img src={u.avatar} alt={u.username} className="wtf-avatar" />
            ) : (
              <div className="wtf-avatar wtf-avatar-placeholder">
                {u.username?.charAt(0).toUpperCase()}
              </div>
            )}
            <div className="wtf-names">
              <span className="wtf-name">{u.fullName || u.username}</span>
              <span className="wtf-username">@{u.username}</span>
            </div>
          </Link>
          <button
            className="wtf-follow-btn"
            onClick={() => handleFollow(u._id)}
            disabled={followed[u._id]}
          >
            {followed[u._id] ? 'Following' : 'Follow'}
          </button>
        </div>
      ))}
    </div>
  );
};

export default WhoToFollowWidget;
